import React, { Component } from 'react';

import classNames from 'classnames';
import { Toggle } from 'components/toggle';
import { InfoTooltip } from 'components/tooltip';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './InputToggle.scss';

class InputToggle extends Component {
  static propTypes = {
    className: PropTypes.string,
    labelTooltip: PropTypes.string,
    labelValue: PropTypes.string,
    labelClass: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool
  };

  render() {
    const {
      labelValue,
      labelTooltip,
      name,
      value,
      className,
      labelClass,
      ...props
    } = this.props;
    const componentClassName = classNames('toggle__wrapper', className);

    return (
      <div className={componentClassName}>
        <div className="input__toggle__label">
          <label className={labelClass}>
            <I18n label={labelValue} />
          </label>
          {labelTooltip && <InfoTooltip text={labelTooltip} />}
        </div>

        <Toggle
          id={name}
          key="input__toggle__label"
          name={name}
          checked={value}
          {...props}
        />
      </div>
    );
  }
}

export default InputToggle;
